import { Exit, Interactive, Player } from "../objects";
import levelGoalKit from "./levelGoalKit";
class Level13 extends levelGoalKit {
  constructor() {
    super();
    this.name = "Risky business";
    this.diamondsGoal = 9;
    this.interactiveCounts = 0;
    this.quakeTriggerIndex = Math.trunc(Math.random() * 100) % 4;
    this.playerOriginPosition = null;
  }

  get id() {
    return this.constructor.key;
  }

  async connectToScene(scene) {
    await super.connectToScene(scene);
    this.playerOriginPosition = { ...this.player.position };
  }

  async onInteractWith(el) {
    super.onInteractWith(el);

    if (el.isClass(Exit)) {
      this.onComplete();
    }
    if (el.isClass(Interactive)) {
      if (this.interactiveCounts === this.quakeTriggerIndex) {
        this.player.disconnect();
        const areaWidth = 17;
        const areaHeight = 11;
        await this.playEarthquake(
          {
            x1: this.playerOriginPosition.x - areaWidth - 1,
            x2: this.playerOriginPosition.x - 1,
            y1: el.position.y - areaHeight,
            y2: this.playerOriginPosition.y,
          },
          3
        );
        this.player.reconnect();
      }
      this.interactiveCounts++;
    }
  }

  onAddElement(el) {
    if (el.isClass(Player)) {
      el.power = 1;
      el.hasPickaxe = true;
    }
  }
}
Level13.key = "level_13";
export default Level13;
